import { render, staticRenderFns } from "./TechnologicalInnovation.vue?vue&type=template&id=134153b3&scoped=true"
import script from "./TechnologicalInnovation.vue?vue&type=script&lang=js"
export * from "./TechnologicalInnovation.vue?vue&type=script&lang=js"
import style0 from "./TechnologicalInnovation.vue?vue&type=style&index=0&id=134153b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134153b3",
  null
  
)

export default component.exports